import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label, FormGroup, Col } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import './CertifiedAccreditationModal.css';
import moment from 'moment';

export const AVAILABLE_ACTIONS = {
    SHOW_DETAILS: 'show_details',
    REMOVE: 'remove'
};

class CertifiedAccreditationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.data)) {
            let newData = nextProps.data;
            this.setState({
                data: newData
            });
        } else {
            this.clearData();
        }
    }

    render() {
        if (this.state.data) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.onCancelHandle} className="certified-accreditation-modal-container">
                    <ModalBody>
                        {this.renderLabel()}
                        {this.renderAccreditationData()}
                        <div className="modal-buttons-container">
                            {this.renderButtons()}
                        </div>
                    </ModalBody>
                </Modal>
            );
        } else {
            return null;
        }
    }

    renderLabel = () => {
        switch (this.props.action) {
            case AVAILABLE_ACTIONS.SHOW_DETAILS:
                return <h5>{_.get(this.props.translation, 'applicant_accreditations_management.accreditation_details_label')}</h5>;
            case AVAILABLE_ACTIONS.REMOVE:
                return <h6>{_.get(this.props.translation, 'applicant_accreditations_management.remove_accreditation_alert')}</h6>;
            default:
                return '';
        }
    };

    renderAccreditationData() {
        return (
            <div>
                <FormGroup row >
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'accreditation.accreditation_title_orig_label') + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{this.props.data.titleOriginal}</Label>
                    </Col>
                </FormGroup>
                <FormGroup row >
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'accreditation.accreditation_title_en_label') + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{this.props.data.titleEn}</Label>
                    </Col>
                </FormGroup>
                {this.getAdditionalTitlesData()}
                <FormGroup row >
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'accreditation.date_issued_label') + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{moment(this.props.data.dateIssued).format("L")}</Label>
                    </Col>
                </FormGroup>
                <FormGroup row >
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'applicant_accreditations_management.issued_by_label') + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{this.props.data.issuedByName + ', ' + _.get(this.props.translation, 'countries.' + this.props.data.issuedByCountry)}</Label>
                    </Col>
                </FormGroup>
                <FormGroup row >
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'accreditation.level_label') + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{_.get(this.props.translation, 'levels.' + this.props.data.level)}</Label>
                    </Col>
                </FormGroup>
            </div>
        )
    }

    getAdditionalTitlesData = () => {
        let result = [];

        _.forEach(this.props.data.additionalTitles, (title, key) => {
            result.push (
                <FormGroup row key={key}>
                    <Col sm={4}>
                        <h6>{_.get(this.props.translation, 'langs.' + key) + ":"}</h6>
                    </Col>
                    <Col sm={8}>
                        <Label>{title}</Label>
                    </Col>
                </FormGroup>
            );
        });

        return result;
    };

    renderButtons = () => {
        switch (this.props.action) {
            case AVAILABLE_ACTIONS.SHOW_DETAILS:
                return (
                    <Button className="olive-green-btn right" onClick={this.onCancelHandle}>{_.get(this.props.translation, sharedLabelsPath.okey_button)}</Button>
                );
            case AVAILABLE_ACTIONS.REMOVE:
                return [
                    <Button className="left" onClick={this.onCancelHandle} key="cancel">{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>,
                    <Button className="olive-green-btn right" onClick={this.onRemove} key="remove">{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                ];
            default:
                return null;
        }
    };

    onCancelHandle = () => {
        this.clearData();
        this.props.onCancel();
    };

    onRemove = () => {
        this.props.onRemove();
    }

    clearData = () => {
        this.setState({
            data: null
        });
    };
}

CertifiedAccreditationModal.propTypes = {
    action: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    id: PropTypes.string,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onRemove: PropTypes.func,
};

export default CertifiedAccreditationModal;



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/certifiedAccreditationModal/CertifiedAccreditationModal.js